const infoHTML = {
  "About": require('./infoHTML/About2.html'),
  "AboutNative": require('./infoHTML/AboutNative.html'),
  "Notes": require('./infoHTML/Notes.html'),
  "NotesNative": require('./infoHTML/NotesNative.html'),
};

export default infoHTML;
